import { useContext } from 'react';

import { MosaicContext } from '../components/Provider/MosaicContext';

export const useMosaicContext = () => {
  return useContext(MosaicContext);
};
